module.exports = __webpack_public_path__ + "img/facebook.861c15e8.svg";